import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IExportReportScreenState } from '../../settlements/interfaces/poi-settlement-report.interface';
import { MaxCountLimitReport } from '../../../modules/transactions/enums/max-count-limit-report.enum';
import { Router } from '@angular/router';

@Component({
    selector: 'portal-export-report',
    templateUrl: './export-report.component.html',
    standalone: false
})
export class ExportReportComponent {
  @Input() isDeviceMobile: boolean;
  @Input() buttonText: string;
  @Input() titleText: string;
  @Input() loading = false;
  @Input() newPayloadLoading = false;
  @Input() reportCount? = 0;
  @Input() readonly maximumReportLimit?: number = MaxCountLimitReport.MaxReportLimit;
  @Input() set exportReportScreenState(value: IExportReportScreenState) {
    if (value) this.exportScreenState = value;
  }
  @Output() generateReportEmitter: EventEmitter<void> = new EventEmitter();
  @Output() resetExportReportScreenStateEmitter: EventEmitter<void> = new EventEmitter();

  get exportReportScreenState(): IExportReportScreenState {
    return this.exportScreenState;
  }
  isOpened = false;
  buttonConfig = {
    title: $localize`Copy`,
    class: 'button icon is-transparent has-text-primary',
    iconClass: 'far fa-clone',
  };
  exportScreenState: IExportReportScreenState = {
    initialScreen: true,
    loadingScreen: false,
    successScreen: false,
  };

  constructor(private router: Router) {}

  toggleShow(): void {
    this.isOpened = !this.isOpened;

    if (this.exportScreenState.reportId) {
      this.resetState();
    }
  }

  onGenerateReport(): void {
    this.generateReportEmitter.emit();
  }

  closeSideBar(): void {
    this.isOpened = false;
    this.resetState();
  }

  goto(): void {
    if (this.exportScreenState?.reportId) {
      const queryParams = { reportid: this.exportScreenState.reportId, download: 'true' };
      this.router.navigate(['/reports/generated-reports'], { queryParams });
    }
  }

  clickOutside(): void {
    if (this.isOpened) {
      this.isOpened = false;
    }
    if (this.exportScreenState.reportId) {
      this.resetState();
    }
  }

  private resetState(): void {
    if (this.exportScreenState.successScreen) {
      this.resetExportReportScreenStateEmitter.emit();
    }
  }
}
